import { PayrollWeek } from "../components/PayrollWeek";

export default function WeekHoursCheck() {
    return (
        <div className="px-4 sm:px-10 py-6 sm:py-10 max-w-5xl mx-auto animate-fade-in" data-testid="week-hours-check-page">
            <div className="label-eyebrow mb-2">Řemeslníci</div>
            <h1 className="font-display text-4xl font-black tracking-tighter text-slate-900 mb-2">Kontrola hodin týdne</h1>
            <p className="text-sm text-slate-600 mb-6">Zkontrolujte hodiny lidí za týden a potvrďte je. Uzávěrku a výplatu dělá vlastník / administrátor.</p>
            <PayrollWeek moneyAllowed={false} />
        </div>
    );
}
